/**
 * Persist marketplace install context across /register refresh.
 * Cleared after successful registration.
 */
export type EconomicRegistrationSession = {
    token: string;
    agreementNumber: string | number;
    company?: {
        name?: string;
        [key: string]: any;
    };
};

const STORAGE_KEY = "economic_registration_session";

export const saveEconomicRegistrationSession = (session: EconomicRegistrationSession): void => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } catch {
        // ignore quota / private mode
    }
};

export const getEconomicRegistrationSession = (): EconomicRegistrationSession | null => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (!parsed?.token || parsed?.agreementNumber == null || parsed?.agreementNumber === "") {
            return null;
        }
        return parsed as EconomicRegistrationSession;
    } catch {
        return null;
    }
};

export const clearEconomicRegistrationSession = (): void => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
};
